const dataFetcher = async (uri, config) => {
  let fetchUri = uri;
  if (fetchUri) {
    if (config && Object.keys(config).length) {
      Object.keys(config).map(
        (key) => (fetchUri = fetchUri.replaceAll(`{${key}}`, config[key]))
      );
    }

    return await fetch(fetchUri, { method: 'GET' })
      .then((data) => data.json())
      .then((json) => {
        return json;
      })
      .catch((error) => {
        return { error };
      });
  }
};

export { dataFetcher };
